// Indonesian translations for all dynamic portfolio content from mock.js
export const portfolioDataId = {
  title: "IT Manager & Full Stack Developer",
  tagline:
    "IT Manager yang juga bisa code. Saya mengelola infrastruktur, server, dan jaringan—sekaligus membangun aplikasi web full-stack. Fokus saya: sistem yang andal, tim yang produktif, dan solusi yang benar-benar berdampak untuk bisnis Anda.",
  bio: "Saya profesional teknologi dengan latar belakang kuat di operasi IT, infrastruktur, dan pengembangan software. Saat ini menjabat sebagai IT Manager sekaligus aktif membangun solusi digital sebagai Full Stack Developer.\n\nKarier saya berawal dari technical support dan system administration—fondasi yang solid dalam troubleshooting, infrastruktur, dan eksekusi yang bisa diandalkan. Dari sana saya berkembang ke manajemen IT, monitoring, dan perbaikan proses yang berkelanjutan.\n\nYang membedakan saya adalah kombinasi antara kepemimpinan operasional dan kemampuan engineering secara langsung. Saya tidak hanya mengelola sistem—saya juga merancang dan membangunnya. Saya menyukai pekerjaan yang praktis dan terukur, yang benar-benar mengubah cara tim bekerja setiap hari.",
  availability:
    "Terbuka untuk kolaborasi terpilih, diskusi teknis, dan proyek engineering yang terstruktur dengan baik.",

  stats: [
    { label: "Tahun di teknologi", value: "10+" },
    { label: "Lingkup kerja", value: "Ops · Infra" },
    { label: "Keahlian", value: "Full Stack" },
    { label: "Gaya kerja", value: "Hands-on" },
  ],

  projects: [
    // HRMS
    {
      id: 1,
      description:
        "UI bergaya HRIS yang terintegrasi langsung di portofolio: sidebar teal, dashboard dengan widget inbox dan absensi, direktori karyawan, serta placeholder untuk penggajian, rekrutmen, dan pengaturan—data mock tanpa server terpisah.",
    },
    {
      id: 14,
      description:
        "Platform HCM full-stack skala produksi dalam satu monorepo. REST API NestJS + panel admin Next.js mencakup seluruh siklus karyawan: onboarding, absensi, cuti, penggajian, rekrutmen, penilaian kinerja, dan analitik multi-tenant.",
    },
    // Booking
    {
      id: 2,
      description:
        "Prototype booking ruang meeting dan meja kerja yang interaktif: pilih hari, lihat kapasitas ruangan, harga per jam, fasilitas tersedia, serta status tersedia atau penuh—fokus pada UX penjadwalan yang intuitif.",
    },
    // IT Operations
    {
      id: 3,
      description:
        "Demo navigasi mendalam terinspirasi dari tools ITSM: sidebar multi-level yang bisa dilipat, menu layanan dan aset, chrome notifikasi dan pencarian, serta layout konsol—dibangun sebagai demo React mandiri dalam portofolio.",
    },
    {
      id: 21,
      description:
        "Platform pengujian keamanan web full-stack untuk penetration testing yang terotorisasi. Meliputi pemeriksaan OWASP Top 10, analisis TLS/SSL, audit cookie, proteksi SSRF, verifikasi domain, dan pembuatan laporan assessment dalam format PDF.",
    },
    {
      id: 24,
      description:
        "Stack monitoring infrastruktur via Docker Compose: Prometheus untuk pengumpulan metrik, Grafana untuk dashboard, Node Exporter untuk metrik host, AlertManager dengan notifikasi Telegram, dan Uptime Kuma untuk pemantauan endpoint.",
    },
    // Travel
    {
      id: 4,
      description:
        "Website travel concierge premium yang dikemas sebagai bundle statis: slider hero, kartu destinasi, paket tour unggulan, layanan eksklusif, testimoni, estimator anggaran, dan lead generation via WhatsApp—ditampilkan lewat iframe di portofolio.",
    },
    // Finance
    {
      id: 5,
      description:
        "Workspace keuangan personal multi-modul di React: dashboard cashflow dengan Recharts, buku transaksi, akun & kategori, anggaran, kalkulator alokasi, target tabungan, tagihan rutin, aset, dan alur pelaporan—semua berbasis data mock sisi client.",
    },
    {
      id: 12,
      description:
        "Engine trading otomatis modular untuk MetaTrader 5 menggunakan analisis Smart Money Concept (SMC) dalam tiga strategi: Macro, Micro, dan Nano. Dilengkapi validasi break, buffer yang bisa dikonfigurasi, dan ekspor Python untuk backtesting.",
    },
    // E-Commerce
    {
      id: 6,
      description:
        "Toko e-commerce Next.js dengan Prisma dan PostgreSQL untuk kebutuhan bayi sehari-hari—popok, perlengkapan makan, kebersihan, tidur, kesehatan, mainan edukatif, hingga perlengkapan perjalanan—lengkap dengan keranjang, checkout, pesanan, voucher, banner, dan panel admin.",
    },
    {
      id: 17,
      description:
        "Toko pasar makanan Korea full-stack dengan Next.js 15: mega menu, filter dan sorting produk, keranjang belanja, checkout multi-payment (Midtrans, QRIS, transfer manual, Xendit), dan backend Prisma + PostgreSQL.",
    },
    {
      id: 18,
      description:
        "Platform e-commerce monolitik skala produksi dengan Laravel 12 dan MySQL, dilengkapi Elasticsearch untuk pencarian produk. Mendukung manajemen produk multi-vendor, inventaris, pengiriman, payment (Stripe, PayPal, Razorpay), RMA, dan back office admin lengkap.",
    },
    {
      id: 19,
      description:
        "Storefront mobile cross-platform (iOS/Android/Web) dengan Flutter 3 yang mengonsumsi GraphQL API. Fitur notifikasi push Firebase, pengenalan gambar ML Kit untuk pencarian produk, integrasi kamera, dan dukungan update dalam aplikasi.",
    },
    // LMS
    {
      id: 15,
      description:
        "LMS full-stack untuk latihan ujian dan modul belajar premium. Frontend Next.js 14 dengan backend FastAPI, PostgreSQL, Redis caching, dan Google OAuth—dilengkapi dashboard siswa, sesi ujian live, leaderboard, dan integrasi payment Midtrans.",
    },
    {
      id: 16,
      description:
        "Sistem manajemen pembelajaran pra-onboarding karyawan. React + Vite di frontend, Express + PostgreSQL di backend, reverse proxy Nginx, dan deployment Docker Compose. Mendukung modul terstruktur, kuis, progress checklist, FAQ, dan UI dua bahasa.",
    },
    // CMS & IoT
    {
      id: 8,
      description:
        "Panduan museum interaktif berbasis BLE beacon (iBeacon): saat pengunjung mendekati artefak, aplikasi menyajikan cerita digital yang telah dikurasi. Dibangun dengan Next.js, Supabase, Cloudinary, dan aplikasi Android pendamping.",
    },
    {
      id: 22,
      description:
        "CMS headless berbasis Next.js 15 dan Payload CMS 3 dengan SQLite: REST API, sistem redirect UUID BLE untuk routing beacon IoT, versioning konten (draft/published), editor rich-text Lexical, dan panel admin lengkap.",
    },
    // Web App
    {
      id: 7,
      description:
        "Platform SaaS cloud hosting komprehensif: portal pelanggan Next.js, API Hono/Bun, PostgreSQL, Docker. Dilengkapi chatbot AI berbasis Gemini, domain checker, login WhatsApp OTP, payment Xendit/Midtrans, auto-invoicing, Trading VPS dengan noVNC (MT4/MT5), dan email server BillionMail.",
    },
    {
      id: 10,
      description:
        "Platform assessment kesiapan bisnis dan perencanaan enterprise. TanStack Start + Cloudflare Workers + Supabase. Fitur diagnostic scoring, pemodelan keuangan, pitch-deck builder, trade finance desk, dan ekspor multi-format (PDF, Word, Excel, PowerPoint).",
    },
    {
      id: 20,
      description:
        "Web app desktop-first yang mengubah video panjang menjadi Shorts vertikal secara otomatis. Menggunakan FFmpeg untuk cropping, MediaPipe untuk tracking subjek, yt-dlp untuk import YouTube, Claude AI untuk pembuatan caption, dan bot Telegram untuk pemrosesan jarak jauh.",
    },
    // Job Portal
    {
      id: 9,
      description:
        "Portal rekrutmen dua sisi untuk PT Buana Megah Paper Mills. Monorepo React 19 + Express 5 dengan MySQL dan Drizzle ORM. Lengkap dengan listing lowongan publik, tracking pelamar, dashboard rekruter dengan KPI metrics, dan pipeline manajemen wawancara.",
    },
    {
      id: 11,
      description:
        "Platform konsultasi HR multi-halaman untuk 300+ perusahaan Indonesia. Meliputi layanan executive search, assessment center psikometri, analisis beban kerja, dan people analytics—dibangun sebagai situs statis profesional yang menyasar level C-suite dan senior.",
    },
    // Healthcare
    {
      id: 13,
      description:
        "Marketplace B2B yang menghubungkan klien internasional dengan penyedia layanan medis terkemuka di Korea. Frontend React 18 + Vite dengan UI bilingual, fokus pada fasilitasi medical tourism, penjadwalan konsultasi, dan pencarian provider.",
    },
    // WordPress
    {
      id: 23,
      description:
        "Landing page produk kecantikan Korea berbasis WordPress + Elementor, dengan environment lokal Docker, Redis object cache, dan PHP 8.2. Enam seksi Elementor: produk, keunggulan, testimoni, dan lead capture via WhatsApp.",
    },
  ],

  education: [
    {
      id: 1,
      degree: "Sarjana Teknik Informatika",
      detail:
        "Fondasi akademis yang kuat di bidang teknologi informasi, pemikiran sistem, dan pemecahan masalah berbasis software—menjadi landasan untuk karier di operasi IT maupun software engineering.",
    },
    {
      id: 2,
      degree: "Pembelajaran Berkelanjutan",
      detail:
        "Berkomitmen untuk terus berkembang lewat pengalaman nyata, pembelajaran terstruktur, sertifikasi, dan pekerjaan langsung di bidang operasi IT, infrastruktur, dan full-stack development.",
    },
  ],

  skills: [
    {
      category: "Operasi IT & Infrastruktur",
      items: [
        { name: "Manajemen operasi IT", level: 94 },
        { name: "Infrastruktur IT", level: 93 },
        { name: "System administration", level: 92 },
        { name: "Server administration", level: 92 },
        { name: "Network administration", level: 90 },
        { name: "Windows Server", level: 91 },
        { name: "Linux", level: 90 },
        { name: "Manajemen NAS & VPS", level: 89 },
        { name: "Monitoring", level: 91 },
        { name: "VPN & keamanan jaringan", level: 88 },
      ],
    },
    {
      category: "Software Development",
      items: [
        { name: "Full stack development", level: 93 },
        { name: "Web application development", level: 92 },
        { name: "Frontend development", level: 91 },
        { name: "Backend development", level: 91 },
        { name: "Database design", level: 89 },
        { name: "API integration", level: 90 },
        { name: "Tools & sistem internal", level: 92 },
        { name: "System design", level: 88 },
      ],
    },
    {
      category: "Tools & Teknologi",
      items: [
        { name: "Docker", level: 88 },
        { name: "MikroTik", level: 87 },
        { name: "AWS", level: 86 },
        { name: "Cloud platforms", level: 88 },
        { name: "Git", level: 90 },
        { name: "Linux", level: 90 },
        { name: "Windows", level: 91 },
        { name: "Monitoring tools", level: 90 },
      ],
    },
  ],

  experience: [
    {
      id: 1,
      description:
        "Memimpin strategi operasi IT dan infrastruktur di seluruh organisasi. Bertanggung jawab atas manajemen infrastruktur, sistem IT, kepemimpinan tim, dan memastikan teknologi selaras dengan tujuan bisnis.",
    },
    {
      id: 2,
      description:
        "Mengelola VPS, NAS, server, jaringan, dan layanan inti. Menjaga uptime dan keamanan di seluruh stack infrastruktur—monitoring, hardening keamanan, dokumentasi, dan perbaikan berkelanjutan.",
    },
    {
      id: 3,
      description:
        "Memberikan support IT langsung untuk hardware, storage NAS, dan perangkat pengguna. Memastikan operasional harian berjalan lancar melalui troubleshooting cepat dan pemeliharaan proaktif.",
    },
    {
      id: 4,
      description:
        "Support IT entry-level mencakup NAS, jaringan, dan troubleshooting umum. Membangun skill dasar di bidang pemeliharaan infrastruktur dan dukungan pengguna.",
    },
    {
      id: 5,
      description:
        "Support IT on-site di Pasuruan, Jawa Timur. Menangani jaringan wireless, konfigurasi MikroTik, dan troubleshooting perangkat.",
    },
    {
      id: 6,
      description:
        "Implementasi aplikasi NTT baru secara on-site di seluruh Jawa Timur. Mengkoordinasikan deployment, pelatihan, dan dukungan go-live di lokasi klien Surabaya.",
    },
    {
      id: 7,
      description:
        "Mengadakan pelatihan rollout software SDMS baru di jaringan dealer Sidoarjo, Jawa Timur—mencakup penggunaan sistem, alur entry data, dan troubleshooting.",
    },
  ],

  testimonials: [
    {
      id: 1,
      content:
        "Butuh VPS untuk toko online kami, Arif setup Ubuntu, Nginx, dan SSL dalam sehari. Semuanya berjalan lancar sejak hari pertama—tidak ada masalah sama sekali.",
    },
    {
      id: 2,
      content:
        "Landing page-nya lebih rapi dari ekspektasi saya. Langsung paham kebutuhan kami tanpa revisi bolak-balik. Selesai tepat waktu, pasti order lagi.",
    },
    {
      id: 3,
      content:
        "Aplikasi web-nya selesai sesuai jadwal, kodenya bersih dan mudah dibaca. Komunikasi jelas dari brief sampai serah terima. Pas banget untuk startup.",
    },
    {
      id: 4,
      content:
        "Setup monitoring Grafana untuk 12 server kami. Sekarang bisa deteksi masalah sebelum user merasakannya. Dashboard-nya bersih dan alert-nya benar-benar jalan.",
    },
    {
      id: 5,
      content:
        "Seluruh stack kami di-dockerize dan CI/CD GitHub Actions langsung jalan. Waktu deploy turun dari 30 menit jadi di bawah 3 menit. Hasilnya solid tanpa drama.",
    },
    {
      id: 6,
      content:
        "Server selalu jadi bottleneck toko kami. Setelah dioptimasi, waktu load turun dari 8 detik ke bawah 2 detik. Itu saja sudah balik modal untuk seluruh proyeknya.",
    },
  ],
};
